localStorage.getItem('NG_TRANSLATE_LANG_KEY') === 'en' ? import('@/app/blood-bank/theme/blood-bank.scss') : import('@/app/blood-bank/theme/blood-bank-rtl.scss');
import localeEn from '@/app/blood-bank/locales/en'
import localeAr from '@/app/blood-bank/locales/ar'
import Loader from '@/app/shared/layouts/components/loader/loader.vue';
import { showPopupNotification } from '@/app/shared/grid-functionality/grid-functionality.js';
import donorBanner from "@/app/blood-bank/shared/components/donor-banner/donor-banner.vue";

import { getDonationStatus, getDonorBannerStatusEnums } from '@/app/blood-bank/shared/config/bloodBank-enums.js';
import $ from 'jquery';
const BloodUnits = () => import('./blood-units/blood-units.vue');
const LabInvestigationBeforDonation = () => import('./lab-investigation-before-donation/lab-investigation-before-donation.vue')
import { bloodDonnationService } from '@/app/blood-bank/shared/services/blood-donnation-service.js';
import { EventBus } from '@/app/shared/services/event-bus.js';

export default {
    name: "donation-details",
    data() {
        return {
            BackToBloodUnit:false,
            donorBannerStatus: getDonorBannerStatusEnums().Donation,
            disableBloodUnitTab: true,
            hideNotification: 5000,
            suffix: 'donation-details',
            isLoading: false,
            donationID: this.$route.query.DonationID,
            donationObj: null,
            activeBloodUnitsTab: false,
            activeLabInvestigationBeforeDonationTab: false,
            
        }
    },
    computed: {        
    },
    methods: {
        showPopupNotification,
        getDonation() {
            if (!this.donationID) return;

            this.isLoading = true;

            bloodDonnationService.GetDonation(this.donationID,
                (result) => {
                    if (result) {
                        if (result.data) {
                            this.donationObj = result.data;

                            this.$refs.donorBanner.LoadPatientData();

                            if (this.donationObj.DonationStatusID == getDonationStatus().Approved ||
                                this.donationObj.HasBloodUnits) {                               
                                    this.disableBloodUnitTab = false;                                  
                            }
                            else {                                
                                    this.disableBloodUnitTab = true;                                   
                            }
                        }
                    }

                    this.isLoading = false;
                },
                (error) => {
                    console.log(error, "Error Message");

                    this.isLoading = false;
                })
        },
        // THIS PART TO MAKE TOOLTIP IN CASE TAB DISABLED 
        bloodUnitsTabMSG(disableTab) {         
            if (disableTab.classList.contains("k-state-disabled")) {
                return `${this.$i18n.t('BloodBank.BloodUnits.BloodUnitsDisableToltip')}`;
            }
            else {
                this.$nextTick(() => {
                $('[role="tooltip"]').css("visibility", "hidden");
                    return '';
                })
            }                
        }       
    },
    components: {
        Loader,
        donorBanner,
        LabInvestigationBeforDonation,
        BloodUnits,
    },
    created() {
        if (!this.donationID) {
            this.$router.push({ 'name': '/blood-bank/donation/donors-list/blood-donors-list' });
        }
    },
    mounted() {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();
 
        this.getDonation();

        EventBus.$on(`RefreshDonationObj`, () => {
            this.getDonation();
        });
        // THIS PART WHEN WE USE BACK BUTTON WE GO TO THE SECOND TAB
        if (this.$route.query.Tab == 2) {
            console.log(this.$route);
            this.activeBloodUnitsTab = true;       
            $("#bloodCompatibilityTabStrip").kendoTabStrip().data("kendoTabStrip").select(1);           
        }
        else  {
            this.activeLabInvestigationBeforeDonationTab = true;
            $("#bloodCompatibilityTabStrip").kendoTabStrip().data("kendoTabStrip").select(0);           
        }       
    },
    beforeDestroy() {
        EventBus.$off('RefreshDonationObj');
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    }
};